export function openMenuSidenav() {
  // ========= menu open/close (no Materialize) =========
  (function () {
    // compute scrollbar width once
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--sbw", sbw + "px");

    const body = document.body;
    const menu = document.getElementById("menu");
    const backdrop =
      document.querySelector(".menu_backdrop") ||
      (() => {
        const el = document.createElement("div");
        el.className = "menu_backdrop";
        document.body.appendChild(el);
        return el;
      })();
    const btn = document.querySelector(".menu_button");

    let lastFocused = null;

    function openMenu() {
      lastFocused = document.activeElement;
      body.classList.add("nav-open");
      menu.classList.add("is-open");
      backdrop.classList.add("is-open");
      btn?.setAttribute("aria-expanded", "true");
      // focus the menu for accessibility
      menu.setAttribute("tabindex", "-1");
      menu.focus();
      // trap focus (very light)
      document.addEventListener("keydown", onKeydown);
    }

    function closeMenu() {
      backdrop.classList.remove("is-open");
      menu.classList.remove("is-open");
      body.classList.remove("nav-open");
      btn?.setAttribute("aria-expanded", "false");
      document.removeEventListener("keydown", onKeydown);
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu();
      }
    }

    // open/close wiring
    btn?.addEventListener("click", (e) => {
      e.preventDefault();
      const open = !menu.classList.contains("is-open");
      open ? openMenu() : closeMenu();
    });
    backdrop.addEventListener("click", closeMenu);
    // click outside right sheet content
    menu.addEventListener("click", (e) => {
      if (e.target === menu) closeMenu();
    });

    // ========= smooth jump from menu to anchors =========

    // OPTIONAL: use GSAP ScrollTo (uncomment if you want smooth)
    // gsap.registerPlugin(ScrollToPlugin);

    const headerOffset = () => document.querySelector(".site-header")?.getBoundingClientRect().height || 0;

    // If you use small .st-start markers, this keeps default behavior too:
    document.documentElement.style.setProperty("--header-offset", "80px"); // adjust
    const style = document.createElement("style");
    style.textContent = `[id]{scroll-margin-top:var(--header-offset,80px)} .st-start{scroll-margin-top:var(--header-offset,80px)}`;
    document.head.appendChild(style);

    function samePage(url) {
      try {
        url = new URL(url, location.href);
      } catch {
        return false;
      }
      return url.pathname === location.pathname;
    }

    function scrollNativeTo(el, slug) {
      // native: use scrollIntoView and let scroll-margin-top do the offset
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      history.replaceState(null, "", "#" + slug);
    }

    function scrollGsapTo(el, slug) {
      const y = window.scrollY + el.getBoundingClientRect().top - headerOffset();
      // gsap.killTweensOf(window);
      // gsap.to(window, { duration: .8, ease: 'power2.out', scrollTo: { y, autoKill: false } });
      window.scrollTo({ top: y, behavior: "smooth" }); // if you prefer native smooth
      history.replaceState(null, "", "#" + slug);
    }

    function getAnchor(slug) {
      return document.querySelector(`.st-start[data-st-id="${slug}"]`) || document.getElementById(slug + "-start") || document.getElementById(slug);
    }

    // Intercept clicks inside the menu
    document.querySelector(".main_menu")?.addEventListener("click", (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;
      if (!samePage(a.href)) return; // go to another page normally
      e.preventDefault();

      const slug = new URL(a.href, location.href).hash.slice(1);
      const el = getAnchor(slug);
      // Close menu FIRST so no scroll-restore can override our jump
      closeMenu();

      if (el) {
        requestAnimationFrame(() => {
          // choose one:
          // scrollGsapTo(el, slug);
          scrollNativeTo(el, slug);
        });
      }
    });
  })();
}
